import React from 'react';
import './DoubleFlightCheckIn.css';
import { FlightDetails } from '../interface/flight.details';
import moment from 'moment';
import { BUCKET_URL } from '../utils/env-utils';
import FlipText from './FlipText';
import AnimatedCodeshare from './AnimatedCodeshare';
import Destination from './Destination';
import { getRemarksTranslation, normalizeCode } from '../utils/common.utils';
import { RemarkToCodeMapping } from '@industronics/fids-utils';

interface DoubleFlightCheckInProps {
  flights: FlightDetails[]
}

const DoubleFlightCheckIn: React.FC<DoubleFlightCheckInProps> = ({ flights }) => {
  return (
    <div className="design2-container">
      {/* First Column - OD 2108 PENANG */}
      <div className="design2-column">
        <div className="design2-header">
          <div className="d-flex justify-content-between align-items-center">
            <img
              src={`${BUCKET_URL}/0180x0045/${flights[0]?.flightNumber?.split(' ')[0]
                }.bmp`}
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).src =
                  `${BUCKET_URL}/0180x0045/${flights[0]?.flightNumber?.split(' ')[0]
                  }.jpg`;
              }}
              alt="Airline Logo" className="design2-alliance-logo" />
          </div>
        </div>
        <div className="design2-info">
          <h1 className="design2-flight-number">{flights[0].flightNumber}</h1>
          <div className="design2-codeshare-container ms-3">
            {flights[0]?.codeShareFlight?.length > 0 && (<AnimatedCodeshare mainClassName='d-flex align-items-center' labelClassName='ms-5 fs-large' codeShareFlights={flights[0].codeShareFlight} />)}
          </div>
          <h2 className="design2-destination"><Destination className='fs-large' flight={flights[0]} /></h2>
          <div className="design2-flight-info-container">
            <div>
              <h2 >Scheduled departure time :
                {flights[0]?.scheduledTravelTime && (
                  <span
                    className="bp-time-value"
                    style={{ fontSize: '43px', }}
                  >
                    {moment(flights[0]?.scheduledTravelTime).format('HH:mm')}

                    {!moment(flights[0]?.scheduledTravelTime)
                      .utcOffset(8)
                      .isSame(moment(), 'day') && (
                        <span>
                          <br />
                          <span style={{ color: 'yellow', marginLeft: '350px' }}>
                            {moment(flights[0]?.scheduledTravelTime).format(
                              'DD MMM'
                            )}
                          </span>
                        </span>
                      )}
                  </span>
                )}
              </h2>
              <h2 style={{ fontSize: '2rem' }}>
                Estimated departure time :{(flights[0]?.ETA || flights[0]?.scheduledTravelTime) && (
                  <span
                    className="bp-time-value"
                    style={{ fontSize: '44px', }}
                  >

                    {moment(flights[0]?.ETA || flights[0]?.scheduledTravelTime).format('HH:mm')}

                    {!moment(flights[0]?.ETA || flights[0]?.scheduledTravelTime)
                      .utcOffset(8)
                      .isSame(moment(), 'day') && (

                        <span>
                          <br />
                          <span style={{ color: 'yellow', marginLeft: '345px', }}>
                            {moment(flights[0]?.ETA || flights[0]?.scheduledTravelTime).format(
                              'DD MMM'
                            )}
                          </span>

                        </span>
                      )}
                  </span>
                )}
              </h2>
            </div>
            <h3 className="design2-gate-info">GATE <br /> {normalizeCode(flights[0].loungeCode)}</h3>
          </div>
          <FlipText className='ms-2 fs-large' dataList={getRemarksTranslation(RemarkToCodeMapping.GO_TO_GATE, flights[0].stations)} />
        </div>
      </div>

      {/* Second Column - OD 0705 JEDDAH */}
      <div className="design2-column">
        <div className="design2-header">
          <div className="d-flex justify-content-between align-items-center">
            <img
              src={`${BUCKET_URL}/0180x0045/${flights[1]?.flightNumber?.split(' ')[0]
                }.bmp`}
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).src =
                  `${BUCKET_URL}/0180x0045/P${flights[1]?.flightNumber?.split(' ')[0]
                  }.jpg`;
              }}
              alt="Airline Logo" className="design2-alliance-logo" />
          </div>
        </div>
        <div className="design2-info">
          <h1 className="design2-flight-number">{flights[1].flightNumber}</h1>
          <div className="design2-codeshare-container ms-3">
            {flights[1]?.codeShareFlight?.length > 0 && (<AnimatedCodeshare mainClassName='d-flex align-items-center' labelClassName='ms-5 fs-large' codeShareFlights={flights[1].codeShareFlight} />)}
          </div>
          <h2 className="design2-destination ms-2">
            <Destination className='fs-large' flight={flights[1]} />
          </h2>
          <div className="design2-flight-info-container">
            <div>
              <h2 className='ms-2'>Scheduled departure time :{flights[1]?.scheduledTravelTime && (
                <span
                  className="bp-time-value"
                  style={{ fontSize: '43px', }}
                >
                  {moment(flights[1]?.scheduledTravelTime).format('HH:mm')}

                  {!moment(flights[1]?.scheduledTravelTime)
                    .utcOffset(8)
                    .isSame(moment(), 'day') && (
                      <span>
                        <br />
                        <span style={{ color: 'yellow', marginLeft: '350px' }}>
                          {moment(flights[1]?.scheduledTravelTime).format(
                            'DD MMM'
                          )}
                        </span>
                      </span>
                    )}
                </span>
              )}</h2>
              <h2 className='ms-2'>Estimated departure time :{(flights[1]?.ETA || flights[1]?.scheduledTravelTime) && (
                <span
                  className="bp-time-value"
                  style={{ fontSize: '43px', }}
                >
                  {moment(flights[1]?.ETA || flights[1]?.scheduledTravelTime).format('HH:mm')}

                  {!moment(flights[1]?.ETA || flights[1]?.scheduledTravelTime)
                    .utcOffset(8)
                    .isSame(moment(), 'day') && (
                      <span >
                        <br />
                        <span style={{ color: 'yellow', marginLeft: '350px' }}>
                          {moment(flights[1]?.ETA || flights[1]?.scheduledTravelTime).format(
                            'DD MMM'
                          )}
                        </span>
                      </span>
                    )}
                </span>
              )}</h2>
            </div>
            <h3 className="design2-gate-info">GATE <br /> {normalizeCode(flights[1].loungeCode)}</h3>
          </div>
          <FlipText className='ms-3 fs-large' dataList={getRemarksTranslation(RemarkToCodeMapping.GO_TO_GATE, flights[1].stations)} />
        </div>
      </div>
    </div>
  );
};

export default DoubleFlightCheckIn;